import { Box, Typography } from "@mui/material";
import {
  getNomeOrgaoPublicacaoPedido,
  getTenantMunicipio,
} from "../utils/tenantDocumentConfig";
import { modeloPublicacaoSistemaEnum } from "../utils/constants";

const COR_FUNDO_PREVIA = "#fafafa";
const COR_FUNDO_DOCUMENTO = "#ffffff";
const COR_TEXTO_PREVIA = "#111111";
const COR_TEXTO_LEGENDA = "#555555";
const COR_BORDA_DOCUMENTO = "#111111";

const TITULOS_POR_MODELO = {
  [modeloPublicacaoSistemaEnum.CONCESSAO_LICENCA_AUTORIZACAO]:
    "CONCESSÃO DE LICENÇA/AUTORIZAÇÃO AMBIENTAL",
  [modeloPublicacaoSistemaEnum.CONCESSAO_REGULARIZACAO_LICENCA]:
    "CONCESSÃO DE REGULARIZAÇÃO DE LICENÇA AMBIENTAL",
  [modeloPublicacaoSistemaEnum.CONCESSAO_RENOVACAO_LICENCA_AUTORIZACAO]:
    "CONCESSÃO DE RENOVAÇÃO DE LICENÇA/AUTORIZAÇÃO AMBIENTAL",
};

function formatarData(valor) {
  if (!valor) return "";
  if (typeof valor === "string" && /^\d{4}-\d{2}-\d{2}/.test(valor)) {
    const [ano, mes, dia] = valor.slice(0, 10).split("-");
    return `${dia}/${mes}/${ano}`;
  }
  const data = new Date(valor);
  if (Number.isNaN(data.getTime())) return "";
  const day = String(data.getDate()).padStart(2, "0");
  const month = String(data.getMonth() + 1).padStart(2, "0");
  const year = data.getFullYear();
  return `${day}/${month}/${year}`;
}

function montarObjetoConcessao(modelo, tipoLicencaNome) {
  const tipo = (tipoLicencaNome || "").trim() || "(1)";
  if (modelo === modeloPublicacaoSistemaEnum.CONCESSAO_REGULARIZACAO_LICENCA) {
    return `a Regularização da ${tipo}`;
  }
  if (modelo === modeloPublicacaoSistemaEnum.CONCESSAO_RENOVACAO_LICENCA_AUTORIZACAO) {
    return `a Renovação da ${tipo}`;
  }
  return `a ${tipo}`;
}

export default function PreviaModeloPublicacaoRecebimento({
  modelo,
  nomeOuRazaoSocial,
  tipoLicencaNome,
  atividade,
  endereco,
  dataValidade,
  dataEmissao,
}) {
  const municipio = getTenantMunicipio().municipio || "__________";
  const orgao = getNomeOrgaoPublicacaoPedido();
  const titular =
    (nomeOuRazaoSocial || "").trim() || "(Nome do titular da licença/autorização)";
  const titulo =
    TITULOS_POR_MODELO[modelo] || "CONCESSÃO DE LICENÇA/AUTORIZAÇÃO AMBIENTAL";
  const objeto = montarObjetoConcessao(modelo, tipoLicencaNome);
  const atividadeTexto = (atividade || "").trim() || "(2)";
  const enderecoTexto = (endereco || "").trim() || "(3)";
  const validadeTexto = formatarData(dataValidade) || "DATA DE VALIDADE NÃO INFORMADA";
  const dataTexto = formatarData(dataEmissao || new Date());

  return (
    <Box
      sx={{
        border: "1px solid",
        borderColor: "divider",
        bgcolor: COR_FUNDO_PREVIA,
        color: COR_TEXTO_PREVIA,
        p: 2,
        borderRadius: 1,
      }}
    >
      <Typography
        variant="caption"
        sx={{ display: "block", mb: 1, color: COR_TEXTO_LEGENDA }}
      >
        Prévia do modelo (o PDF final incluirá cabeçalho e rodapé do PDF Layout)
      </Typography>

      <Typography
        align="center"
        color="inherit"
        sx={{ fontWeight: 700, fontSize: "0.95rem", mb: 2, textTransform: "uppercase" }}
      >
        {titulo}
      </Typography>

      <Box
        sx={{
          border: `2px solid ${COR_BORDA_DOCUMENTO}`,
          p: 2,
          bgcolor: COR_FUNDO_DOCUMENTO,
          color: COR_TEXTO_PREVIA,
        }}
      >
        <Typography
          align="center"
          color="inherit"
          sx={{ fontWeight: 700, mb: 1.5, fontSize: "0.95rem" }}
        >
          {titular}
        </Typography>
        <Typography
          color="inherit"
          sx={{ fontSize: "0.875rem", mb: 1.5, lineHeight: 1.5 }}
        >
          Torna público que recebeu da {orgao} {objeto} para{" "}
          <strong>{atividadeTexto}</strong>, localizada no município de{" "}
          <strong>{municipio}</strong>, na <strong>{enderecoTexto}</strong>, com
          validade de <strong>{validadeTexto}</strong>.
        </Typography>
        <Typography color="inherit" sx={{ fontSize: "0.875rem", lineHeight: 1.5, mb: 1.5 }}>
          Foi determinado o cumprimento das exigências contidas nas Normas e
          Instruções de Licenciamento da {orgao}.
        </Typography>
        {dataTexto && (
          <Typography
            color="inherit"
            align="right"
            sx={{ fontSize: "0.875rem", lineHeight: 1.5 }}
          >
            Data: {dataTexto}
          </Typography>
        )}
      </Box>
    </Box>
  );
}
